import moment from 'moment'
import { DATE_FORMATS } from '@/utils/dateHelpers'
import { useReselector } from '@/src/utils/sharedHooks'

import { Card, Text, Accordion, Separator, CardColors, Badge } from '@/ui'
import { selectUserTaxCalculationWithinActiveQuarter } from '@/selectors/userTaxCalculation.selectors'
import { TypographyStyles } from '@/styles'
// TODO: Migrate to V2
import { selectActiveQuarterlyTaxEstimateDetails } from '@/featuresV1/Admin/QuarterlyTaxEstimateDetails/quarterlyTaxEstimateDetails.selector'

export const QTETimeline = () => {
  const activeQuarterDetails = useReselector(
    selectActiveQuarterlyTaxEstimateDetails
  )

  const calculation = useReselector(selectUserTaxCalculationWithinActiveQuarter)
  const isSingleState = calculation?.isSingleState

  const {
    taxQuarter,
    clientNotifiedAt: notifiedAt,
    irsPaymentDueAt,
    calculationStartsAt,
    checklistLaunchDate,
  } = activeQuarterDetails ?? {}

  if (!activeQuarterDetails) {
    return null
  }
  return (
    <Card color={CardColors.LEVEL_1} className="w-full">
      <Accordion type="single" collapsible>
        <Accordion.Item value="faqs">
          <Accordion.Trigger>
            <Text variant={TypographyStyles.H3}>Timeline</Text>
          </Accordion.Trigger>
          <Accordion.Content>
            {/* Step 1 */}
            <div className="mt-4 space-y-2">
              <Badge variant="default" size="md" color="white">
                <Text variant={TypographyStyles.BODY_MD}>1</Text>
              </Badge>
              <Text variant={TypographyStyles.H3}>
                Between{' '}
                {moment
                  .utc(checklistLaunchDate)
                  .format(DATE_FORMATS.DISPLAY_LONG)}{' '}
                and{' '}
                {moment
                  .utc(calculationStartsAt)
                  .subtract(1, 'day')
                  .format(DATE_FORMATS.DISPLAY_LONG)}
              </Text>
              <Text>Complete your quarterly checklist</Text>
              <Separator />
            </div>

            {/* Step 2 */}
            <div className="space-y-2">
              <Badge variant="default" size="md" color="white">
                <Text variant={TypographyStyles.BODY_MD}>2</Text>
              </Badge>
              <Text variant={TypographyStyles.H3}>
                By {moment.utc(notifiedAt).format(DATE_FORMATS.DISPLAY_LONG)}
              </Text>
              <Text>Heard sends you your Q{taxQuarter} estimates</Text>
              <Text className="mt-2">
                {!isSingleState
                  ? '(if quarterly checklist was completed by deadline)'
                  : 'Note: Heard will send you an estimate within one hour of completing your checklist.'}
              </Text>
              <Separator />
            </div>

            {/* Step 3 */}
            <div className="space-y-2">
              <Badge variant="default" size="md" color="white">
                <Text variant={TypographyStyles.BODY_MD}>3</Text>
              </Badge>
              <Text variant={TypographyStyles.H3}>
                By{' '}
                {moment.utc(irsPaymentDueAt).format(DATE_FORMATS.DISPLAY_LONG)}
              </Text>
              <Text>
                Submit your quarterly tax payments to the IRS and{' '}
                {!isSingleState ? 'applicable states' : 'your home state'}.
              </Text>
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion>
    </Card>
  )
}
